export default  {	
	data () {
		return { 
			filter: {
				inicial: this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null
			}
		}
	},
	async created () { 	
		// solo frontend this.searchGetIdb({tabla:'afiliacion_registro'})
	},
	destroyed()
	{
		this.resetCrud({state: 'dataGet/informes_afiliaciones/data'})
	}
}
